export const getFilterLabel = filter => {
  const {
    filterValue,
    filterMetadata
  } = filter;
  const {
    label,
    type
  } = filterMetadata;
  switch (type) {
    case "text":
      return `${label}: ${filterValue}`;
    case "select":
      const optionLabel = filterMetadata.options.find(({
        value: optionValue
      }) => optionValue === filterValue).label;
      return `${label}: ${optionLabel}`;
    default:
      return filterValue;
  }
};